import { exportRows, type ExportColumn } from '../lib/exportRows';

/**
 * Exports the CURRENT in-memory rows (whatever is filtered/sorted on screen) to CSV.
 * Pure client-side — no query, no mutation. Drop into any table toolbar.
 */
export function ExportButton<T>({
  rows,
  columns,
  filename,
  label = 'Export CSV',
  disabled,
}: {
  rows: T[];
  columns: ExportColumn<T>[];
  filename: string;
  label?: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      disabled={disabled || rows.length === 0}
      onClick={() => exportRows(filename, rows, columns)}
      title={`Export ${rows.length} row${rows.length === 1 ? '' : 's'} to CSV`}
      className="inline-flex items-center gap-1.5 rounded-lg border border-border bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-muted transition-colors hover:bg-white/[0.07] hover:text-white disabled:opacity-40"
    >
      {label}
      <span className="tabular-nums text-mutedDim">({rows.length.toLocaleString()})</span>
    </button>
  );
}
